/* eslint-disable no-unused-vars */
import _ from 'lodash';
import React, { useState, useEffect, useRef } from 'react';
//import axios from 'axios';
import dayjs from 'dayjs';
import moment from 'moment';
import { connect } from 'react-redux';
import { DownOutlined } from '@ant-design/icons';
import { decode as base64_decode } from 'base-64';
import ReactEcharts from '../Utils/Echarts/Echarts';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { DRIFT, IPAddress, RBSLOOKUPMaster, RBSPREDMODEL } from '../../../commons/api';
import { Button, DatePicker, Form, Input, Select, Tabs, Tree, message, Modal } from 'antd';
import {
  StyledForm,
  StyledSubHeading,
} from '../CSS/style';
import {
  getList,
  RegisterModel,
  getDeployHistory,
  DeployModel,
  getMetaData
} from '../Utils/FormCalls';
const { TextArea } = Input;
const { TabPane } = Tabs;
const { TreeNode } = Tree;
const { Option } = Select;
const APIList = {
  getDeviceList: `${DRIFT.GetDevice}`,
  getParameterList: `${DRIFT.DriftParameters}`,
  getMetrics: `${RBSLOOKUPMaster.LookUpItemsGetById}`,
  driftCreate: `${IPAddress.PREDICTIONIP}/pred_reqs/datadrift`,
  driftSave: `${DRIFT.CREATE}`,
  driftGraphResults: `${DRIFT.DataDrift}`,
  getById: `${DRIFT.GET}`,
  getData: `${RBSPREDMODEL.ReadMetadata}`,
};
const MonitorDrift = (props) => {
  const [formObject, setFormObject] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [dataSource, setDataSource] = useState([]);
  // const [deviceListModal, setDeviceListModal] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [dataDrift, setDataDrift] = useState([]);
  const [parameterList, setParameterList] = useState([]);
  const [dataDistribution, setDataDistribution] = useState([]);
  const [metricsData, setMetricsData] = useState([]);
  const [reference, setReference] = useState([]);
  const [tableResults, setTableResults] = useState(true);
  const [current, setCurrent] = useState([]);
  const [graphResults, setGraphResults] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expandedKey, setExpandedKey] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [modelName, setModelName] = useState('');
  const [relatedTags, setRelatedTags] = useState([]);
  const [fromTime, setFromTime] = useState([]);
  const [toTime, setToTime] = useState([]);
  const hRef = useRef();
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const searchParams = new URLSearchParams(props.location.search);
  //       const newParams = Object.fromEntries(searchParams.entries());
  //       const metaData = await getMetaData(APIList.getData, 'ModelId', newParams.ModelId);
  //       if (newParams.ModelId) {
  //         const metaData = await getMetaData(APIList.getData, 'ModelId', newParams.ModelId);
  //         // Format date fields in metaData
  //         const formattedMetaData = _.cloneDeepWith(metaData, (value) => {
  //           if (value !== null && value !== undefined) {
  //             return {
  //               ...value,
  //               TrainPeriodFrom: value.TrainPeriodFrom ? moment(value.TrainPeriodFrom).utc().format('YYYY-MM-DD HH:mm:ss') : null,
  //               TrainPeriodTo: value.TrainPeriodTo ? moment(value.TrainPeriodTo).utc().format('YYYY-MM-DD HH:mm:ss') : null,
  //               EvalPeriodFrom: value.EvalPeriodFrom ? moment(value.EvalPeriodFrom).utc().format('YYYY-MM-DD HH:mm:ss') : null,
  //               EvalPeriodTo: value.EvalPeriodTo ? moment(value.EvalPeriodTo).utc().format('YYYY-MM-DD HH:mm:ss') : null,
  //               CreatedTime: value.CreatedTime ? moment(value.CreatedTime).utc().local().format('YYYY-MM-DD HH:mm:ss') : null,
  //             };
  //           }
  //           return _.noop();
  //         });
  //         // const modelName = formattedMetaData.ModelName || '';
  //         // const relatedTags = formattedMetaData.RelatedTagsList || [];
  //         // const fromTime = formattedMetaData.TrainPeriodFrom || null;
  //         // const toTime = formattedMetaData.TrainPeriodTo || null;
  //         // setModelName(modelName);
  //         // setRelatedTags(relatedTags);
  //         // setFromTime(fromTime);
  //         // setToTime(toTime);
  //       }
  //       // Fetch device list and metrics data
  //       const response = await getList(APIList.getDeviceList);
  //       const metricsData = await getDeployHistory(APIList.getMetrics, 'LookupName', 'DRIFTMETRICS');
  //       setDeviceList(response&&Array.isArray(response) ? response : []);
  //       setMetricsData(metricsData);
  //       props.location.state = undefined;
  //       // Prepare form object
  //       const parameterList = {
  //         DeviceCode: [Object.keys(metaData.RelatedTagsList)[0] || '']
  //       };
  //       const response1 = await RegisterModel(APIList.getParameterList, parameterList);
  //       const FormObject = {
  //         ...formObject,
  //         ModelName: metaData.ModelName,
  //         Tags:  metaData.RelatedTagsList[Object.keys(metaData.RelatedTagsList)[0]] || [],
  //         Devices: [Object.keys(metaData.RelatedTagsList)[0] || ''],
  //         RefFromDate: metaData.TrainPeriodFrom ? dayjs.utc(metaData.TrainPeriodFrom, 'YYYY-MM-DD HH:mm:ss') : null,
  //         RefToDate: metaData.TrainPeriodTo ? dayjs.utc(metaData.TrainPeriodTo, 'YYYY-MM-DD HH:mm:ss') : null
  //       };
  //       if (hRef.current) {
  //         hRef.current.setFieldsValue({ ...FormObject });
  //       }
  //       setFormObject(FormObject);
  //       setParameterList(response1?.data?.Operational || []);
  //       if (modelName === '') {
  //         const path = props.location.pathname.split('/rubus/RbsAnalytics/MonitorDrift/');
  //         const Id = path[1] ? base64_decode(path[1]) : null;
  //         if (Id&& Id !== null) {
  //           const data = await getMetaData(APIList.getById, 'Id', Id);
  //           const formObject = data || {};
  //           const formattedFormObject = _.cloneDeepWith(formObject, (value) => {
  //             if (value !== null && value !== undefined) {
  //               return {
  //                 ...value,
  //                 CurrentFromDate: value.CurrentFromDate ? dayjs.utc(value.CurrentFromDate, 'YYYY-MM-DD HH:mm:ss').local() : null,
  //                 CurrentToDate: value.CurrentToDate ? dayjs.utc(value.CurrentToDate, 'YYYY-MM-DD HH:mm:ss').local() : null,
  //                 RefFromDate: value.RefFromDate ? dayjs.utc(value.RefFromDate, 'YYYY-MM-DD HH:mm:ss').local() : null,
  //                 RefToDate: value.RefToDate ? dayjs.utc(value.RefToDate, 'YYYY-MM-DD HH:mm:ss').local() : null,
  //               };
  //             }
  //             return _.noop();
  //           });
  //           if (hRef.current) {
  //             hRef.current.setFieldsValue({ ...formObject });
  //           }
  //           const parameterList = {
  //             DeviceCode: formObject.Devices || []
  //           };
  //           const response2 = await RegisterModel(APIList.getParameterList, parameterList);
  //           setFormObject(formObject);
  //           setParameterList(response2?.data?.Operational || []);
  //           setTableResults(true);
  //           setDataSource(data?.Result || []);
  //         }
  //       } else if (metaData?.ModelName && metaData?.RelatedTagsList) {
  //         let parameterList = { DeviceCode: [Object.keys(metaData.RelatedTagsList)[0]] };
  //         let response = await RegisterModel(APIList.getParameterList, parameterList);
  //         const FormObject = {
  //           ...formObject,
  //           ModelName: metaData.ModelName,
  //           Tags: metaData.RelatedTagsList[Object.keys(metaData.RelatedTagsList)[0]] || [],
  //           Devices: [Object.keys(metaData.RelatedTagsList)[0]],
  //           RefFromDate: metaData.TrainPeriodFrom ? dayjs.utc(metaData.TrainPeriodFrom, 'YYYY-MM-DD HH:mm:ss') : null,
  //           RefToDate: metaData.TrainPeriodTo ? dayjs.utc(metaData.TrainPeriodTo, 'YYYY-MM-DD HH:mm:ss') : null
  //         };
  //         if (hRef.current) {
  //           hRef.current.setFieldsValue({ ...FormObject });
  //         }
  //         setFormObject(FormObject);
  //         setParameterList(response?.data?.Operational || []);
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   fetchData();
  // }, [props.location.search]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        let searchParams = new URLSearchParams(props.location.search);
        let newParams = Object.fromEntries([...searchParams]);
        let response = await getList(APIList.getDeviceList);
        let metricsData = await getDeployHistory(APIList.getMetrics, 'LookupName', 'DRIFTMETRICS');
        setDeviceList(response && Array.isArray(response) ? response : []);
        setMetricsData(metricsData);
        const metaData = await getMetaData(APIList.getData, 'ModelId', newParams.ModelId);

        if (newParams.ModelId === undefined) {
          let path = props.location.pathname.split('/rubus/RbsAnalytics/MonitorDrift/');
          let Id = path && path[1] && base64_decode(path[1]) ? base64_decode(path[1]) : null;
          if (Id) {    
            const path =props.location.pathname.split('/rubus/RbsAnalytics/MonitorDrift/');
            const Id = path && path[1] && base64_decode(path[1]) ? base64_decode(path[1]) : null;
            const data = await getMetaData(APIList.getById, 'Id', Id);
            const formObject = data || {};
            const FormObject = {
              ...formObject,
              Description:formObject.Name,
              ModelName: formObject.ModelName,
              Tags: formObject.Tags&&Array.isArray(formObject.Tags) || [],
              ['Drift Metrics']:formObject.Methods	&& Array.isArray(formObject.Methods),
              Devices: [Object.keys(formObject.Devices)[0]],
              ['Ref From Date']: formObject.RefFromDate	 ? dayjs.utc(formObject.RefFromDate	, 'YYYY-MM-DD HH:mm:ss') : null,
              ['Ref To Date']: formObject.RefToDate	? dayjs.utc(formObject.RefToDate	, 'YYYY-MM-DD HH:mm:ss') : null,
              ['Current From Date']:formObject.CurrentFromDate? dayjs.utc(formObject.CurrentFromDate, 'YYYY-MM-DD HH:mm:ss') : null,
              ['Current To Date']:formObject.CurrentToDate? dayjs.utc(formObject.CurrentToDate, 'YYYY-MM-DD HH:mm:ss') : null,
              Comments:formObject.Comments,
            };
            setFormObject(FormObject);
            ['CurrentFromDate', 'CurrentToDate', 'RefFromDate', 'RefToDate'].forEach(dateField => {
              if (formObject[dateField]) {
                formObject[dateField] = dayjs.utc(formObject[dateField], 'YYYY-MM-DD HH:mm:ss').local();
              }
            }

        );
            if (hRef.current) {
              hRef.current.setFieldsValue(formObject );
            }
            let parameterList = { DeviceCode: formObject.Devices };
            let response = await RegisterModel(APIList.getParameterList, parameterList);
            setFormObject(formObject);
            setParameterList(response?.data?.Operational || []);
            setTableResults(true);
            setDataSource(data?.Result || []);
          }

        }
         else if(newParams.ModelId !== undefined){ if(metaData?.ModelName && metaData?.RelatedTagsList) {
          let parameterList = { DeviceCode: [Object.keys(metaData.RelatedTagsList)[0]] };
          let response = await RegisterModel(APIList.getParameterList, parameterList);
          const FormObject = {
            ...formObject,
            ModelName: metaData.ModelName,
            Tags: metaData.RelatedTagsList[Object.keys(metaData.RelatedTagsList)[0]] || [],
            Devices: [Object.keys(metaData.RelatedTagsList)[0]],
            RefFromDate: metaData.TrainPeriodFrom ? dayjs.utc(metaData.TrainPeriodFrom, 'YYYY-MM-DD HH:mm:ss') : null,
            RefToDate: metaData.TrainPeriodTo ? dayjs.utc(metaData.TrainPeriodTo, 'YYYY-MM-DD HH:mm:ss') : null
          };
          if (hRef.current) {
            hRef.current.setFieldsValue(FormObject );
          }
          setFormObject(FormObject);
          setParameterList(response?.data?.Operational || []);
        }}
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [props.location.search]); 
  useEffect(() => {
    if (props.userProfile !== userProfile || props.translationCache !== translationCache) {
      setUserProfile(props.userProfile);
      setTranslationCache(props.translationCache);
    }
  }, [props.userProfile, props.translationCache]);
  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode title={item.key} key={item.key} dataRef={item.key}>
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.value} title={item.key} dataRef={item.value} />;
      })
    );
  };
  const onCheck = async (key, value) => {
    const formObject = hRef.current.getFieldsValue();
    const FormObject = {
      ...formObject,
      [key]: value
    };
    let parameterList = {
      DeviceCode: value
    };
    let response = await RegisterModel(APIList.getParameterList, parameterList);
    hRef.current.setFieldsValue(FormObject);
    setFormObject(FormObject);
    setParameterList(
      response && response.data && response.data.Operational && Array.isArray(response.data.Operational)
        ? response.data.Operational
        : []
    );
  };
  const onFormSubmit = () => {
    setLoading(true);
    hRef.current
      .validateFields()
      .then(async (values) => {
        _.cloneDeepWith(values, (value) => {
          return value !== null && value !== undefined
            ? {
              ...value,
              ...(value['RefFromDate']
                ? (value['RefFromDate'] = dayjs(value.RefFromDate)
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss'))
                : null),
              ...(value['RefToDate']
                ? (value['RefToDate'] = dayjs(value.RefToDate)
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss'))
                : null),
              ...(value['CurrentFromDate']
                ? (value['CurrentFromDate'] = dayjs(value.CurrentFromDate)
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss'))
                : null),
              ...(value['CurrentToDate']
                ? (value['CurrentToDate'] = dayjs(value.CurrentToDate)
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss'))
                : null)
            }
            : null;
        });
        values = {
          ...values,
          UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : ''
        };
        let response = await DeployModel(APIList.driftCreate, values);
        if (response) {
          message.warning(response && response.message);
          setLoading(false);
        }
        setTableResults(true);
        setDataSource(response);
      })
      .catch(() => { });
  };
  // const saveDriftFunc = (payload) => {
  //   const accessToken = localStorage.get('accessToken');
  //   const siteId = localStorage.get('currentSite');
  //   const Object = {
  //     method: 'POST',
  //     url: `${DRIFT.SaveDriftResults}?SiteId=${siteId}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     },
  //     data: payload
  //   };
  //   return axios(Object)
  //     .then((response) => {
  //       return response.data;
  //     })
  //     .catch((err) => {
  //       if (err && err.response && err.response.data && err.response.data.message) {
  //         message.info(translation(err.response.data.message));
  //       }
  //     });
  // };
  const getDriftResults = async (expanded, record) => {
    let formObject = hRef.current.getFieldsValue();
    const siteId = localStorage.get('currentSite');
    let payload = {
      siteId,
      tag: record && record.Tags ? record.Tags : '',
      CurrentFromDate: formObject.CurrentFromDate
        ? dayjs(formObject.CurrentFromDate).utc().format('YYYY-MM-DD HH:mm:ss')
        : '',
      CurrentToDate: formObject.CurrentToDate
        ? dayjs(formObject.CurrentToDate).utc().format('YYYY-MM-DD HH:mm:ss')
        : ''
    };
    let response = await DeployModel(APIList.driftGraphResults, payload);
    if (expanded === false) {
      setExpandedKey(null);
    } else {
      setExpandedKey(record.key);
    }
    let dataDrift = {
      title: {
        text: translation('Drift Calculation')
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '12%',
        bottom: '3%',
        containLabel: true
      },
      yAxis: {
        name: translation('Proportion'),
        nameLocation: 'middle',
        nameGap: 40,
        type: 'value'
        // boundaryGap: [0, 0.01]
      },
      xAxis: {
        name: translation('Value'),
        nameLocation: 'middle',
        nameGap: 20,
        type: 'category',
        data:
          response && response[0] && response[0]['Createdtime'] ? response[0]['Createdtime'] : []
      },
      series: [
        {
          name: translation('Current'),
          type: 'scatter',
          symbolSize: 5,
          data: response && response[0] && response[0]['values'] ? response[0]['values'] : []
        },
        {
          name: translation('Reference'),
          type: 'line',
          areaStyle: {},
          markArea: {
            // itemStyle: {
            //   color: 'rgba(255, 173, 177, 0.4)'
            // },
            data: [
              [
                {
                  name: translation('Peak'),
                  yAxis:
                    record && record.Ref_LowerLimit && record.Ref_LowerLimit
                      ? record.Ref_LowerLimit
                      : []
                },
                {
                  yAxis:
                    record && record.Ref_UpperLimit && record.Ref_UpperLimit
                      ? record.Ref_UpperLimit
                     : []
                }
              ]
            ]
          },
          markLine: {
            symbol: ['none', 'none'],
            label: { show: true },
            data: [
              {
                lineStyle: {
                  type: 'solid',
                  color: 'green'
                },
                label: {
                  formatter: translation('Mean') + '=' + record.Ref_Mean
                },
                name: 'ref_mean',
                yAxis: record && record.Ref_Mean ? record.Ref_Mean : []
              },
              {
                label: {
                  formatter: translation('Min') + '=' + record.Ref_LowerLimit
                },
                name: 'Ref_LowerLimit',
                yAxis: record && record.Ref_LowerLimit ? record.Ref_LowerLimit : []
              },
              {
                label: {
                  formatter: translation('Max') + '=' + record.Ref_UpperLimit
                },
                name: 'Ref_UpperLimit',
                yAxis: record && record.Ref_UpperLimit ? record.Ref_UpperLimit : []
              }
            ]
          }
        }
      ]
    };
    let dataDistribution = {
      title: {
        text: translation('Drift Calculation')
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      yAxis: {
        name: translation('Proportion'),
        nameLocation: 'middle',
        nameGap: 50,
        type: 'value'
      },
      xAxis: {
        name: translation('Value'),
        nameLocation: 'middle',
        nameGap: 20,
        type: 'category',
        data: record && record.X_values ? record.X_values : []
      },
      series: [
        {
          name: translation('Current'),
          type: 'bar',
          data: record && record.Y_current ? record.Y_current : []
        },
        {
          name: translation('Reference'),
          type: 'bar',
          data: record && record.Y_reference ? record.Y_reference : []
        }
      ]
    };
    let reference = {
      title: {
        text: translation('Drift Calculation')
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      yAxis: {
        name: translation('Proportion'),
        nameLocation: 'middle',
        nameGap: 50,
        type: 'value'
        // boundaryGap: [0, 0.01]
      },
      xAxis: {
        name: translation('Value'),
        nameLocation: 'middle',
        nameGap: 20,
        type: 'category',
        data: record && record.X_values ? record.X_values : []
      },
      series: [
        {
          name: translation('Reference'),
          type: 'bar',
          color: '#91cc75',
          data: record && record.Y_reference ? record.Y_reference : []
        }
      ]
    };
    let current = {
      title: {
        text: translation('Drift Calculation')
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      yAxis: {
        name: translation('Proportion'),
        nameLocation: 'middle',
        nameGap: 50,
        type: 'value'
      },
      xAxis: {
        name: translation('Value'),
        nameLocation: 'middle',
        nameGap: 20,
        type: 'category',
        data: record && record.X_values ? record.X_values : []
      },
      series: [
        {
          name: translation('Current'),
          type: 'bar',
          data: record && record.Y_current ? record.Y_current : []
        }
      ]
    };
    setGraphResults(true);
    setDataDrift(dataDrift);
    setDataDistribution(dataDistribution);
    setReference(reference);
    setCurrent(current);
    setExpanded(expanded);
  };
  const saveDrift = async () => {
    let formData = hRef.current && hRef.current.getFieldsValue();
    try {
      const values = await hRef.current.validateFields();
      _.cloneDeepWith(values, (value) => {
        return value !== null && value !== undefined
          ? {
            ...value,
            ...(value['RefFromDate']
              ? (value['RefFromDate'] = dayjs(value.RefFromDate)
                .utc()
                .format('YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['RefToDate']
              ? (value['RefToDate'] = dayjs(value.RefToDate)
                .utc()
                .format('YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['CurrentFromDate']
              ? (value['CurrentFromDate'] = dayjs(value.CurrentFromDate)
                .utc()
                .format('YYYY-MM-DD HH:mm:ss'))
              : null),
            ...(value['CurrentToDate']
              ? (value['CurrentToDate'] = dayjs(value.CurrentToDate)
                .utc()
                .format('YYYY-MM-DD HH:mm:ss'))
              : null)
          }
          : null;
      });
      const accessToken = localStorage.get('accessToken');
      const siteId = localStorage.get('currentSite');
      let payload = {
        method: 'POST',
        url: `${APIList.driftCreate}?SiteId=${siteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          ...values,
          UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : ''
        }
      };
      let response = await RegisterModel(APIList.driftSave, payload);
      message.success(
        response && response.data && response.data.message
          ? translation(response.data.message)
          : ''
      );
    } catch (error) {
      console.error(error);
    }
    // let formObject = this.hRef.current.getFieldsValue();
    // formObject = {
    //   ...formObject,
    //   CurrentFromDate: moment(formObject.CurrentFromDate)
    //     .utc()
    //     .format("YYYY-MM-DD HH:mm:ss"),
    //   CurrentToDate: moment(formObject.CurrentFromDate)
    //     .utc()
    //     .format("YYYY-MM-DD HH:mm:ss"),
    //   RefFromDate: moment(formObject.RefFromDate)
    //     .utc()
    //     .format("YYYY-MM-DD HH:mm:ss"),
    //   RefToDate: moment(formObject.RefToDate)
    //     .utc()
    //     .format("YYYY-MM-DD HH:mm:ss"),
    // };
    // let response = await RegisterModel(APIList.driftSave, formObject);
    // message.success(
    //   response && response.data && response.data.message
    //     ? response.data.message
    //     : ""
    // );
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const columns = [
    {
      title: translation('Feature'),
      dataIndex: 'Tags',
      key: 'Tags'
    },
    {
      title: translation('Description'),
      dataIndex: 'Description',
      key: 'Description'
    },
    {
      title: translation('Drift Metric'),
      dataIndex: 'Methods',
      key: 'Methods'
    },
    {
      title: translation('Drift Detected'),
      dataIndex: 'Drift_Detected',
      key: 'Drift_Detected',
      render: (text) => (text === true ? translation('Yes') : translation('No'))
    },
    {
      title: translation('Drift Score'),
      dataIndex: 'Drift_Score',
      key: 'Drift_Score'
    }
  ];
  const validateMessages = {
    required: `${translation('${label}')}${translation(' is required!')}`
  };
  const formItemLayout = { width: '100%', flex: '50%' };
  return (
    <>
      <StyledSubHeading theme={themeSettings}>
        {translation('Monitor Drift')}
      </StyledSubHeading>
      <StyledForm
        name="ModelDetails"
        ref={hRef}
        autoComplete="off"
        initialValues={formObject}
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '200px' }}
        labelAlign="right"
        onFinish={onFormSubmit}
        //onFinishFailed={onFinishFailed} 
        labelWrap
        validateMessages={validateMessages}
        wrapperCol={{ flex: 1 }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item name="Id"></Form.Item>
          <Form.Item
            label={translation('Description')}
            name="Name"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input
              style={{ width: '70%' }}
              placeholder={translation('Please Enter Description')}
            />
          </Form.Item>
          <Form.Item
            label={translation('Device')}
            name="Devices"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Select
              mode="multiple"
              placeholder={translation('Please Select Device')}
              style={{ width: '70%' }}
             onChange={(value) => onCheck('Devices', value)}
            >
              {deviceList &&
                Array.isArray(deviceList) &&
                deviceList.map((tag) => (
                  <Option value={tag.value} key={tag.key}>
                    {translation(tag.key)}
                  </Option>
                ))}{' '}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Tags')}
            name="Tags"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Select
              maxTagCount="responsive"
              mode="multiple"
              style={{ width: '70%' }}
              placeholder={translation('Please Select Tags')}
            >
              {parameterList &&
                Array.isArray(parameterList) &&
                parameterList.map((tag) => (
                  <Option value={tag.value} key={tag.key}>
                    {translation(tag.value)} - {translation(tag.Description)}
                  </Option>
                ))}{' '}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Drift Metrics')}
            name="Methods"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Select
              mode="multiple"
              style={{ width: '70%' }}
              placeholder={translation('Please Select Drift Metric')}
            >
              {metricsData &&
                Array.isArray(metricsData) &&
                metricsData.map((tag) => (
                  <Option value={tag.key} key={tag.key}>
                    {translation(tag.key)}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('Ref From Date')}
            name="RefFromDate"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <DatePicker
              placeholder={translation('Please Select Ref From Date')}
              showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation('Ref To Date')}
            name="RefToDate"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <DatePicker
              placeholder={translation('Please Select Ref To Date')}
              showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation('Current From Date')}
            name="CurrentFromDate"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <DatePicker
              placeholder={translation('Please Select Current From Date')}
              showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation('Current To Date')}
            name="CurrentToDate"
            rules={[{ required: true }]}
            style={formItemLayout}
          >
            <DatePicker
              placeholder={translation('Please Select Current To Date')}
              showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item label={translation('Comments')} name="Comments" style={formItemLayout}>
            <TextArea
              style={{ width: '70%' }}
              placeholder={translation('Add Comments')}
            />
          </Form.Item>
          <Form.Item
            label={translation('Model Name')}
            name="ModelName"
            // rules={[{ required: true }]}
            style={formItemLayout}
          >
            <Input
              style={{ width: '70%' }}
              placeholder={translation('Please Enter ModelName')}
            />
          </Form.Item>
        </div>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button
              style={{ marginRight: 8 }}
              theme={themeSettings}
              type="primary"
              htmlType="submit"
              data-testid="submitButton"
            >
              {translation('Calculate')}
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              style={{ marginRight: 8 }}
              theme={themeSettings}
              type="primary"
              data-testid="submitButton"
              onClick={() => saveDrift()}
            >
              {translation('Save')}
            </Button>
          </Form.Item>
        </div>
      </StyledForm>
      {tableResults && tableResults === true ? (
        <StyledTable size="small"
          data-testid="workbenchList"
          loading={loading}
          theme={themeSettings}
          dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
          columns={columns}
          onExpand={(expanded, record) => {
            getDriftResults(expanded, record);
          }}
          expandedRowKeys={[expandedKey]}
          expandable={true}
          expandedRowRender={() =>
            expanded === true && graphResults && graphResults === true ? (
              <p style={{ margin: 0 }}>
                <Tabs type="card" defaultActiveKey="1">
                  <TabPane tab={translation('Data Drift')} key="1">
                    <ReactEcharts
                      option={dataDrift}
                      notMerge={true}
                      lazyUpdate={true}
                      style={{
                        height: '300%',
                        width: '100%',
                        marginBottom: '40px'
                      }}
                      className="react_for_echarts"
                    />
                  </TabPane>
                  <TabPane tab={translation('Data Distribution')} key="2">
                    <ReactEcharts
                      option={dataDistribution}
                      notMerge={true}
                      lazyUpdate={true}
                      style={{
                        height: '300%',
                        width: '100%',
                        marginBottom: '40px'
                      }}
                      className="react_for_echarts"
                    />
                  </TabPane>
                  <TabPane tab={translation('Reference/Current Data')} key="3">
                    <ReactEcharts
                      option={reference}
                      notMerge={true}
                      lazyUpdate={true}
                      style={{
                        height: '300%',
                        width: '100%',
                        marginBottom: '40px'
                      }}
                      className="react_for_echarts"
                    />
                    <ReactEcharts
                      option={current}
                      notMerge={true}
                      lazyUpdate={true}
                      style={{
                        height: '300%',
                        width: '100%',
                        marginBottom: '40px'
                      }}
                      className="react_for_echarts"
                    />
                  </TabPane>
                </Tabs>
              </p>
            ) : null
          }
          rowExpandable={(record) => record.Feature !== 'Not Expandable'}
        />
      ) : null}
      {/* <Modal
            width="1500px"
            title=""
            open={deviceListModal}
            onCancel={() => {
              setDeviceListModal(false);
            }
            closable
            theme={themeSettings}
            footer={[
              <Button key="back"  onClick{() => {
                setDeviceListModal(false);
             }}
>
                {translation('Close')}
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => 
                  setDeviceListModal(false)
                }}
              >
                {translation('Save')}
              </Button>
            ]}
            >
            <Tree
              checkable
              onCheck={(e) => onCheck('devices', e)}
              switcherIcon={<DownOutlined />}
          // checkedKeys={
          //   predictionRequestInfo && predictionRequestInfo["Metrics"]
          //     ? predictionRequestInfo["Metrics"]
          //     : ""
          // }
            >
              {renderTreeNodes(deviceList)}
            </Tree>
            </Modal> */}
    </>
  );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(MonitorDrift);
